var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBGeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#075975"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66797 14.9987C7.45547 11.1954 10.8871 8.33203 15.0013 8.33203C19.1155 8.33203 22.5471 11.1954 23.3346 14.9987C22.5471 18.802 19.1155 21.6654 15.0013 21.6654C10.8871 21.6654 7.45547 18.802 6.66797 14.9987ZM15.0013 19.1654C16.1064 19.1654 17.1662 18.7264 17.9476 17.945C18.729 17.1636 19.168 16.1038 19.168 14.9987C19.168 13.8936 18.729 12.8338 17.9476 12.0524C17.1662 11.271 16.1064 10.832 15.0013 10.832C13.8962 10.832 12.8364 11.271 12.055 12.0524C11.2736 12.8338 10.8346 13.8936 10.8346 14.9987C10.8346 16.1038 11.2736 17.1636 12.055 17.945C12.8364 18.7264 13.8962 19.1654 15.0013 19.1654ZM15.0013 17.4987C15.6643 17.4987 16.3002 17.2353 16.7691 16.7665C17.2379 16.2976 17.5013 15.6617 17.5013 14.9987C17.5013 14.3357 17.2379 13.6998 16.7691 13.2309C16.3002 12.7621 15.6643 12.4987 15.0013 12.4987C14.3383 12.4987 13.7024 12.7621 13.2335 13.2309C12.7647 13.6998 12.5013 14.3357 12.5013 14.9987C12.5013 15.6617 12.7647 16.2976 13.2335 16.7665C13.7024 17.2353 14.3383 17.4987 15.0013 17.4987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGeye);
export default __webpack_public_path__ + "static/media/BGeye.61aadd97c26013de470077d80af57d12.svg";
export { ForwardRef as ReactComponent };